/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
const productCardMarkup = `<div class="swym-wishlist-grid">
  {{#products}} 
  <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
    <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
      <span class="swym-icon">
      </span>
    </button>
    <div class="swym-wishlist-image-wrapper">
      <img alt="" class="swym-wishlist-image" src="{{iu}}">
    </div>
    <button class="swym-is-button">
      <div class="swym-title swym-title-1">
      {{dt}}
      </div>
    </button>
    <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
      {{variantinfo}}
    </div>
    <div class="swym-product-price swym-text swym-text-1">
      <div class="swym-product-final-price swym-value">
      {{cu}}{{pr}}
      </div>
    </div>
    <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
      {{#isInCart}}カートに追加する{{/isInCart}}{{^isInCart}}カートに追加する{{/isInCart}}
    </button>
  </a>
  {{/products}}
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  const productId = e.currentTarget.getAttribute("data-product-id");
  const variantId = e.currentTarget.getAttribute("data-variant-id");
  const du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "追加しています...";
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = "カートに追加しました";
      e.target.setAttribute("data-state-cart", "swym-added");
      console.log("Successfully added product to cart.", c);
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  const epi = +e.currentTarget.getAttribute("data-variant-id");
  const empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

// 価格を日本円としてフォーマットする
function formatPrice(price) {
  const formatter = new Intl.NumberFormat("ja-JP");
  return formatter.format(price);
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    console.log(products);
    const wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    const formattedWishlistedProducts = products.map(function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.pr = formatPrice(p.pr); // 新しいフォーマット関数を使用して価格をフォーマットする
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
      return p;
    });
    const productCardsMarkup = SwymUtils.renderTemplateString(
      productCardMarkup,
      {
        products: formattedWishlistedProducts,
      }
    );
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

function attachClickListeners() {
  const addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  const removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (let i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
  //   Remove Buttons
  for (let k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
